import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const VendorCommoditiesModule = {
  state: {
    loading: false,
    errorMessage: null,
    VENDORCOMMODITIES: [],
    ALLVENDORCOMMODITIES: [],
    VENDOR: [],
    VENDORS: [],

    totalPages: 1,
  },
  getters: {
    VendorCommoditiesloading: (state) => state.loading,
    VendorCommodities: (state) => state.VENDORCOMMODITIES,
    VendorCommoditiesVendor: (state) => state.VENDOR,
    VendorCommoditiesVendors: (state) => state.VENDORS,
    VendorCommoditiesTotalPages: (state) => state.totalPages,
    VendorCommoditieserrorMessage: (state) => state.errorMessage,
    AllVendorCommodities: (state) => state.ALLVENDORCOMMODITIES,
  },
  actions: {
    [ACTIONS.VENDORS_COMMODITIES_GETALL]: (context, query) => {
      var { commit, state } = context;
      commit(ACTIONS.VENDORS_COMMODITIES_GETALL_PENDING);
      return new Promise((resolve, reject) => {
        var url = "vendors/GetAllVendorCommodities" + query;
        Api.get(url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(
                ACTIONS.VENDORS_COMMODITIES_GETALL_SUCCESS,
                data.ResponseData,
              );
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(
                ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR,
                data.StatusMessage,
              );
            } else {
              commit(ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(
                ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR,
                "Error " + err.status,
              );
            }
            if (err.request) {
              commit(ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(
                ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.VENDORS_COMMODITIES_GETALL_SUCCESS]: (state, data) => {
      state.loading = false;
      state.errorMessage = null;
      state.totalPages = data.totalRecords;
      state.VENDORCOMMODITIES = data.vendorCommodities;
      state.VENDOR = data.vendor;
      state.VENDORS = data.vendors;
      state.ALLVENDORCOMMODITIES = data.AllVendorCommodities;
    },
    [ACTIONS.VENDORS_COMMODITIES_GETALL_PENDING]: (state, data) => {
      state.loading = true;
      state.errorMessage = null;
      state.VENDORCOMMODITIES = [];
      state.VENDOR = [];
      state.VENDORS = [];
    },
    [ACTIONS.VENDORS_COMMODITIES_GETALL_ERROR]: (state, msg) => {
      state.loading = false;
      state.errorMessage = msg;
    },
  },
};

export default VendorCommoditiesModule;
